import { IDocumentRes } from 'models/documents';

import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { addDocument, deleteDocument, getDocuments } from '../thunks/commonDocumentsThunk';

type CommonDocumentsSlice = {
    documents: IDocumentRes[];
    page: number;
    pageSize: number;
    isLoading: boolean;
};

const initialState: CommonDocumentsSlice = {
    documents: [],
    page: 1,
    pageSize: 10,
    isLoading: false
};

const commonDocumentsSlice = createSlice({
    name: 'common-documents',
    initialState,
    reducers: {
        setPage: (state, action: PayloadAction<number>) => {
            state.page = action.payload;
        },
        setPageSize: (state, action: PayloadAction<number>) => {
            state.pageSize = action.payload;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(getDocuments.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(getDocuments.fulfilled, (state, action) => {
                state.isLoading = false;
                state.documents = action.payload.data;
            })
            .addCase(addDocument.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(addDocument.fulfilled, (state, action) => {
                console.log(action.payload, 'action.payload');
                state.isLoading = false;
                // state.documents = [...state.documents, action.payload];
            })
            .addCase(addDocument.rejected, (state) => {
                state.isLoading = false;
            })
            .addCase(deleteDocument.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(deleteDocument.fulfilled, (state) => {
                // state.documents = state.documents.filter((doc) => doc.id !== action.payload.data.id);
                state.isLoading = false;
            })
            .addCase(deleteDocument.rejected, (state) => {
                state.isLoading = false;
            });
    },
});

// eslint-disable-next-line no-empty-pattern
export const { setPage, setPageSize } = commonDocumentsSlice.actions;

export default commonDocumentsSlice.reducer;
